var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 14.6004V17.1004C18.3341 17.3325 18.2866 17.5622 18.1936 17.7749C18.1006 17.9875 17.9643 18.1784 17.7933 18.3353C17.6222 18.4922 17.4203 18.6116 17.2005 18.686C16.9806 18.7603 16.7477 18.788 16.5165 18.7671C13.9522 18.4884 11.489 17.6122 9.32486 16.2087C7.31139 14.9293 5.60431 13.2222 4.32486 11.2087C2.91651 9.03474 2.04007 6.55957 1.76653 3.98374C1.7457 3.7533 1.77309 3.52104 1.84695 3.30176C1.9208 3.08248 2.03951 2.88098 2.1955 2.71009C2.3515 2.5392 2.54137 2.40266 2.75302 2.30917C2.96468 2.21569 3.19348 2.16729 3.42486 2.16707H5.92486C6.32928 2.16309 6.72136 2.30631 7.028 2.57002C7.33464 2.83373 7.53493 3.19995 7.59153 3.60041C7.69705 4.40046 7.89274 5.18601 8.17486 5.94207C8.28698 6.24034 8.31125 6.5645 8.24478 6.87614C8.17832 7.18778 8.02392 7.47383 7.79986 7.70041L6.74153 8.75874C7.92783 10.845 9.65524 12.5724 11.7415 13.7587L12.7999 12.7004C13.0264 12.4764 13.3125 12.3219 13.6241 12.2555C13.9358 12.189 14.2599 12.2133 14.5582 12.3254C15.3143 12.6075 16.0998 12.8032 16.8999 12.9087C17.3047 12.9658 17.6744 13.1697 17.9386 13.4817C18.2029 13.7936 18.3433 14.1917 18.3332 14.6004Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.d1354ac05ed8c338bde37d1cfe256337.svg";
export { ForwardRef as ReactComponent };